import { render, staticRenderFns } from "./PurchaseListForm.vue?vue&type=template&id=783fd500&scoped=true&"
import script from "./PurchaseListForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783fd500",
  null
  
)

export default component.exports